import React from "react";
import fr from "@/content/fr";
import ResidencePage from "@/pages/ResidencePage";

export const BeautyPage = () => (
  <ResidencePage content={fr.beauty} idPrefix="beauty" />
);

export default BeautyPage;
